import { createUseStyles } from "react-jss";

const styles = createUseStyles({
  summaryTab: {
    //
  }
});

export default styles;